import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { IFetchResponse } from "@preveil-api";
// Important: store must be imported before any src/common imports to eliminate circular dependencies
// eslint-disable-next-line import/order
import { store } from "./store/configureStore";
import { getAppConfiguration, AppConfiguration, GlobalErrorMessages, ServerConfiguration } from "src/common";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css";
import "react-tooltip/dist/react-tooltip.css";
import "./assets/scss/main.scss";

const startApp = async () => {
    // NOTE: Set Config default setting to .env (undefined) when in error fetching server config
    const response = await getAppConfiguration() as IFetchResponse<ServerConfiguration>;
    response.isError && console.error(GlobalErrorMessages.error_fetching_server_config);
    const config = new AppConfiguration((!response.isError) ? response.data : undefined);

    //  NOTE: Render Root and Provider with App after config was fetched
    const rootElement = document.getElementById("root");
    if (!rootElement) throw new Error("Failed to find the root element");
    const root = createRoot(rootElement);
    root.render(
        <Provider store={store}>
            <App config={config} />
        </Provider>
    );


    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
};

startApp();
